"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
require("./SFDialog.css");
var DialogTitle = function (_a) {
    var title = _a.title, onClose = _a.onClose;
    return (react_1.default.createElement(DialogTitle_1.default, { className: "dialog-title" },
        react_1.default.createElement("div", { className: "title" }, title),
        onClose ? (react_1.default.createElement(IconButton_1.default, { "aria-label": "close", onClick: onClose },
            react_1.default.createElement(Close_1.default, null))) : null));
};
var DialogContent = function (_a) {
    var content = _a.content;
    return (react_1.default.createElement("div", { className: "dialog-content" },
        react_1.default.createElement("div", { className: "dialog-content-wrapper" }, content)));
};
var DialogFooter = function (props) {
    if (props.customFooter) {
        return react_1.default.createElement("div", { className: "dialog-footer" }, props.customFooter);
    }
    else if (props.footerButtons) {
        if (props.footerButtons.centerButton) {
            return (react_1.default.createElement("div", { className: "dialog-footer center" },
                react_1.default.createElement("div", { className: "button-wrapper" },
                    react_1.default.createElement(Button_1.default, { variant: "contained", onClick: props.footerButtons.centerButton.action, disabled: props.footerButtons.centerButton.disabled, className: props.footerButtons.centerButton.classes
                            ? props.footerButtons.centerButton.classes.join(' ')
                            : '' }, props.footerButtons.centerButton.text))));
        }
        else if (props.footerButtons.twoButtons) {
            return (react_1.default.createElement("div", { className: "dialog-footer two-buttons" },
                react_1.default.createElement("div", { className: "button-wrapper" },
                    !props.footerButtons.twoButtons.leftButton.hideButton ? (react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: props.footerButtons.twoButtons.leftButton.action, disabled: props.footerButtons.twoButtons.leftButton.disabled, className: "left-button " + (props.footerButtons.twoButtons.leftButton.classes
                            ? props.footerButtons.twoButtons.leftButton.classes.join(' ')
                            : '') }, props.footerButtons.twoButtons.leftButton.text)) : (''),
                    !props.footerButtons.twoButtons.rightButton.hideButton ? (react_1.default.createElement(Button_1.default, { variant: "contained", onClick: props.footerButtons.twoButtons.rightButton.action, disabled: props.footerButtons.twoButtons.rightButton.disabled, className: "right-button " + (props.footerButtons.twoButtons.rightButton.classes
                            ? props.footerButtons.twoButtons.rightButton.classes.join(' ')
                            : '') }, props.footerButtons.twoButtons.rightButton.text)) : (''))));
        }
        else {
            return react_1.default.createElement("div", null, "Invalid Params");
        }
    }
    else {
        return react_1.default.createElement("div", null, "Invalid Params");
    }
};
var SFDialog = function (props) {
    var title = props.title, content = props.content, footer = props.footer, onClose = props.onClose, styleClass = props.styleClass;
    return (react_1.default.createElement(Dialog_1.default, { className: "simplifeye-dialog " + (styleClass ? styleClass : ''), open: props.open, maxWidth: false, classes: { paper: 'dialog-paper' }, onClose: onClose },
        react_1.default.createElement(DialogTitle, { title: title, onClose: onClose }),
        react_1.default.createElement(DialogContent, { content: content }),
        footer ? (react_1.default.createElement(DialogFooter, { customFooter: footer.customFooter, footerButtons: footer.footerButtons })) : null));
};
exports.default = SFDialog;
